export default __webpack_public_path__ + "static/media/se.bd15657f.svg";